export const MAIN_CLASS_NAME = 'elma365-toolsets-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;

export const EMPTY_CONTENT_CLASS_NAME = `${CONTENT_CLASS_NAME}_empty`;
export const EMPTY_CONTENT_PLACEHOLDER_CLASS_NAME = `${EMPTY_CONTENT_CLASS_NAME}__placeholder`;
export const NOTHING_FOUND_PLACEHOLDER_CLASS_NAME = `${CONTENT_CLASS_NAME}__nothing-found`;
export const CELL_SWITCH_CLASS_NAME = `${CONTENT_CLASS_NAME}__cell-switch`;
export const TOOLBAR_CLASSNAME = `${CONTENT_CLASS_NAME}__toolbar`;

export const TOOLSETS_PAGE_SIZE = 10;
